/* ============================================================
   Happy Banana — interactive components
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile sticky ATC ---------- */
  function initStickyAtc() {
    var bar = document.getElementById('hbStickyAtc');
    var atcBtn = bar && bar.querySelector('.hb-sticky-atc-btn');
    var priceEl = document.getElementById('hbStickyPrice');
    if (!bar) return;

    // Show only after user scrolls past the main product card
    var mainAtc = document.querySelector('.product-form, product-form, .product__info-container');
    if (!mainAtc) return;

    function syncVisibility() {
      var rect = mainAtc.getBoundingClientRect();
      var atcOffscreen = rect.bottom < 80; // user scrolled past primary ATC
      bar.setAttribute('aria-hidden', atcOffscreen ? 'false' : 'true');
    }

    window.addEventListener('scroll', syncVisibility, { passive: true });
    window.addEventListener('resize', syncVisibility, { passive: true });
    syncVisibility();

    // Sync price + variant title when variant changes (Dawn dispatches `variant:change`)
    document.addEventListener('change', function (evt) {
      if (!evt.target.closest('product-form, .product-form, .product__info-container')) return;
      // Defer to next tick — Dawn updates DOM after this event
      setTimeout(function () {
        var priceTxt = document.querySelector('.product__info-container .price__regular .price-item, .product__info-container .price-item--regular, .product__info-container .price-item--sale');
        var optionTxt = document.querySelector('.product-form__input--pill input[type=radio]:checked + label, .product-form__input--dropdown select option:checked');
        if (priceEl && priceTxt) {
          var label = optionTxt ? optionTxt.textContent.trim() + ' — ' : '';
          priceEl.textContent = label + priceTxt.textContent.trim();
        }
      }, 50);
    });

    // Clicking sticky button scrolls to + clicks the real ATC
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var realBtn = document.querySelector('button.product-form__submit, button[name="add"]');
        if (realBtn) {
          realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { realBtn.click(); }, 350);
        }
      });
    }
  }

  /* ---------- Fit guide modal ---------- */
  function initFitGuide() {
    var modal = document.getElementById('hbFitModal');
    var input = document.getElementById('hbFitInput');
    var result = document.getElementById('hbFitResult');
    if (!modal || !input || !result) return;

    function open() { modal.classList.add('is-open'); input.focus(); }
    function close() { modal.classList.remove('is-open'); }

    document.addEventListener('click', function (e) {
      if (e.target.matches('[data-hb-fit-open]')) { e.preventDefault(); open(); }
      if (e.target.matches('[data-hb-fit-close]') || e.target === modal) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    function recommend(waist) {
      if (!waist || isNaN(waist)) return null;
      if (waist < 31) return { size: 'Small', range: '28–30"' };
      if (waist < 35) return { size: 'Medium', range: '32–34"' };
      if (waist < 39) return { size: 'Large', range: '36–38"' };
      if (waist < 43) return { size: 'Extra Large', range: '40–42"' };
      return { size: 'Extra Large', range: '40–42"', oversized: true };
    }

    input.addEventListener('input', function () {
      var v = parseFloat(input.value);
      var rec = recommend(v);
      if (!rec) {
        result.classList.add('is-empty');
        result.textContent = '';
        return;
      }
      result.classList.remove('is-empty');
      var note = rec.oversized ? ' (you may be above our standard range — contact us for sizing help)' : '';
      result.innerHTML = 'Recommended size: <strong>' + rec.size + '</strong> (waist ' + rec.range + ')' + note;
    });
  }

  /* ---------- Init on DOM ready ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initStickyAtc(); initFitGuide(); });
  } else {
    initStickyAtc();
    initFitGuide();
  }
})();
